import axios from "axios";
import "../common/axiosInterceptor/axios-interceptor";

// const BASE_URL = "http://65.2.111.89:8080/cms/api/";
// const BASE_URL = "http://65.2.111.89:8080/charting/api/";
const BASE_URL = "https://backend-charting.noccarc-web.com/charting/api/";
// const BASE_URL = "http://localhost:8081/charting/api/"

export const loginAPI = async (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}users/signin`,
        data: data
    })
}

export const getChartDataAPI = async (data) => {

    return axios({

        method: 'post',
        url: 'test-url',
        data: data,
        authRequired: true
    })
}

export const getHospitalDetailsAPI = (data) => {

    return axios({
        method: "get",
        url: `${BASE_URL}hospitals/details`,
        data: data,
        authRequired: true
    })
}

export const getPatientBookAPI = (data) => {

    return axios({
        method: "get",
        url: `${BASE_URL}hospitals/patientBook`,
        data: data,
        authRequired: true
    })
}

export const getNotesAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/getNotes/`,
        data: data,
        authRequired: true
    })
}

export const postNotesAPI = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/notes`,
        data: data,
        authRequired: true
    })
}

export const getDoctorNotesOptionsAPI = (data) => {
    return axios({
        method: 'get',
        url: `${data}`,
        authRequired: false,
    })
}

export const getChartVitalsAPI = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/getVitals`,
        data: data,
        authRequired: true
    })
}

export const getChartRSAPI = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/getRS`,
        data: data,
        authRequired: true
    })
}

export const getChartCVSAPI = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/getCVS`,
        data: data,
        authRequired: true
    })
}

export const getChartCNSAPI = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/getCNS`,
        data: data,
        authRequired: true
    })
}

export const getChartNursingCheckAPI = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/getNurseChecks`,
        data: data,
        authRequired: true
    })
}

export const getChartDrugAdministration = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/getDrugAdministrations`,
        data: data,
        authRequired: true
    })
}

export const updateChartVitalsAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/updateVitals`,
        data: data,
        authRequired: true
    })
}

export const updateChartRSAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/updateRS`,
        data: data,
        authRequired: true
    })
}

export const updateChartCVSAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/updateCVS`,
        data: data,
        authRequired: true
    })
}

export const updateChartCNSAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/updateCNS`,
        data: data,
        authRequired: true
    })
}

export const updateChartNurseCheckAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/updateNurseChecks`,
        data: data,
        authRequired: true
    })
}

export const updateChartDrugAdministration = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/updateDrugAdministrations`,
        data: data,
        authRequired: true
    })
}

export const addDrugAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/prescription/addDrug`,
        data: data,
        authRequired: true
    })
}

export const getDrugsAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/prescription/getDrugs`,
        data: data,
        authRequired: true
    })
}

export const updateDrugAPI = (data) => {
    return axios({
        method: "put",
        url: `${BASE_URL}hospitals/prescription/updateDrug`,
        data: data,
        authRequired: true
    })
}

export const addStatOrderAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/prescription/addStatOrder`,
        data: data,
        authRequired: true
    })
}

export const getStatOrdersAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/prescription/getStatOrders`,
        data: data,
        authRequired: true
    })
}

export const updateStatOrderAPI = (data) => {
    return axios({
        method: "put",
        url: `${BASE_URL}hospitals/prescription/updateStatOrder`,
        data: data,
        authRequired: true
    })
}

export const addInfusionAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/prescription/addInfusion`,
        data: data,
        authRequired: true
    })
}

export const getInfusionsAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/prescription/getInfusions`,
        data: data,
        authRequired: true
    })
}

export const updateInfusionAPI = (data) => {
    return axios({
        method: "put",
        url: `${BASE_URL}hospitals/prescription/updateInfusion`,
        data: data,
        authRequired: true
    })
}

export const getChartTimelineAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/getTimeline`,
        data: data,
        authRequired: true
    })
}

export const getAlarmHistoryAPI = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/alarmHistory/getAlarms`,
        data: data,
        authRequired: true
    })
}

export const getIOBalanceAPI = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/getIOBalance`,
        data: data,
        authRequired: true
    })
}

export const updateIOBalanceAPI = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/updateIOBalance`,
        data: data,
        authRequired: true
    })
}
export const updateClinicalScoreAPI = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/updateClinicalScores`,
        data: data,
        authRequired: true
    })
}

export const getClinicalScoreAPI = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/charting/getClinicalScores`,
        data: data,
        authRequired: true
    })
}

export const admitPatientAPI = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/admitPatient`,
        data: data,
        authRequired: true
    })
}

export const dischargePatientAPI = (data) => {

    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/dischargePatient`,
        data: data,
        authRequired: true
    })
}

export const updatePatientAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/updatePatient`,
        data: data,
        authRequired: true
    })
}

export const updateNoteAPI = (data) => {
    return axios({
        method: "post",
        url: `${BASE_URL}hospitals/updateNote`,
        data: data,
        authRequired: true
    })
}

export const getDrugNamesAPI = (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}hospitals/getDrugsDetails`,
        data: data,
        authRequired: true,
    })
}

export const getDiagnosisNamesAPI = (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}hospitals/getDiagnosisDetail`,
        data: data,
        authRequired: true,
    })
}

export const downloadChartAPI = (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}hospitals/generatePdf`,
        data: data,
        authRequired: true,
    })
}

export const getChartingBundlesVapChecksAPI = (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}hospitals/charting/getChartingBundlesVapChecks`,
        data: data,
        authRequired: true,
    })
}
export const getChartingBundlesCautiChecksAPI = (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}hospitals/charting/getChartingBundlesCautiChecks`,
        data: data,
        authRequired: true,
    })
}

export const getChartingBundlesClabsiChecksAPI = (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}hospitals/charting/getChartingBundlesClabsiChecks`,
        data: data,
        authRequired: true,
    })
}
export const updateChartingBundlesVapChecksAPI = (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}hospitals/charting/updateChartingBundlesVapChecks`,
        data: data,
        authRequired: true,
    })
}

export const updateChartingBundlesCautiChecksAPI = (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}hospitals/charting/updateChartingBundlesCautiChecks`,
        data: data,
        authRequired: true,
    })
}

export const updateChartingBundlesClabsiChecksAPI = (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}hospitals/charting/updateChartingBundlesClabsiChecks`,
        data: data,
        authRequired: true,
    })
}

export const autoFetchVitalTrendsAPI = (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}hospitals/autoFetchVitalTrends`,
        data: data,
        authRequired: true,
    })
}

export const createLinesAPI = (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}hospitals/charting/createLines`,
        data: data,
        authRequired: true,
    })
}

export const getLinesAPI = (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}hospitals/charting/getLines`,
        data: data,
        authRequired: true,
    })
}

export const updateLinesAPI = (data) => {
    return axios({
        method: 'post',
        url: `${BASE_URL}hospitals/charting/updateLines`,
        data: data,
        authRequired: true,
    })
}